import React, { Component } from 'react';
import Highcharts from 'highcharts';
 
class CostBarChart extends Component {
  componentDidMount() {
    this.renderChart();
  }
  componentWillReceiveProps(){
    this.renderChart();
  }

 
  renderChart() {
    const { data } = this.props;
    // console.log(data,'prop')
 
    const chartOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Cost Comparison',
      },
      xAxis: {
        categories: data.map(obj => obj.vehicle_type),
        title: {
          text: 'Vehicle Type',
        },
      },
      yAxis: {
        title: {
          text: 'Cost (₹)',
        },
      },
      series: [
        {
          name: 'Manual Cost',
          data: data.map(obj => obj.cost_manual),
        },
        {
          name: 'System Cost',
          data: data.map(obj => obj.cost_system),
        },
      ],
      credits:false
    };
 
    Highcharts.chart('chart-containercost', chartOptions);
  }
 
  render() {
    return <div id="chart-containercost" style={{ width: '100%', height: '400px' }}></div>;
  }
}
 
export default CostBarChart;